const resources = {
    estimatedTotal: 'Total estimé',
    merchandiseSubtotal: 'Sous-total des marchandises',
    giftCardShipping: 'Expédition de la carte-cadeau',
    merchandiseShipping: 'Expédition de la marchandise',
    shippingAndHandling: 'Expédition et manutention',
    discounts: 'Réductions',
    giftWrap: 'Emballage-cadeau',
    gstHst: 'TPS/TVH estimées',
    pst: 'TVP estimée',
    tax: 'Taxes estimées',
    andOtherFees: 'et autres frais',
    storeCreditRedeemed: 'Crédit au compte',
    giftCardRedeemed: 'Carte-cadeau utilisée',
    eGiftCardRedeemed: 'Carte-cadeau électronique utilisée',
    creditCardPayment: 'Paiement par carte de crédit',
    payPalPayment: 'Paiement PayPal',
    submitEdits: 'Soumettre les modifications',
    subscribe: 'S’abonner',
    placeOrder: 'Passer commande',
    shippingHandling: 'Expédition et manutention',
    pickupText: 'Ramassage',
    free: 'GRATUIT',
    shippingHandlingInfo: 'Renseignements sur l’expédition et la manutention',
    salesTax: 'Taxe de vente',
    pointsUsed: 'Utilisé',
    bagFee: 'Frais de sac',
    specialFee: 'Frais spéciaux',
    pointsAfterPickup: 'Vous accumulerez des points Beauty Insider pour cet achat après avoir ramassé votre commande.',
    gotIt: 'Compris',
    autoReplenishmentSavings: 'Économies sur le réapprovisionnement automatique'
};

module.exports = function getResource(label) {
    return resources[label] || label;
};
